<div>


<div class="nav-under px-5 header-borders">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb bg-white" style="margin-bottom: 0;">
      <li class="breadcrumb-item" style="color: #2b78b0; font-weight: 500;">App Content</li>
      <li class="breadcrumb-item active" aria-current="page">Market Info</li>
    </ol>
  </nav>
</div>
<div class="spinner d-flex" *ngIf="loading">
    <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
</div>

<div class="dash-section bg-white" style="margin-top: -23px;">
        <!-- <div class="m-4">&nbsp;</div> -->
    <div class="m-4 row">
      <div class="col-6 p-4">
        <div class="row">
          <div class="col-md-4">
            <span class="btn float-left" style="color: #2b78b0; font-weight: 500;">
              Market prices
            </span>
          </div>
          <div class="col-md-8">
            <input type="text" class="float-left" placeholder="search by name" id="searchItem" (keyup)="filterItemFunction()">
             <!-- <select id="district" class="float-right" style="width: 30%;" (change)="FilterDataByDistrict()">
                <option>all</option>
                <option *ngFor="let item of districts">
                  {{ item }}
                </option>
            </select> -->

            <div class="float-right district-drop-down">
              <b>&nbsp;District</b>
              <div>
                  <select id="district" style="border: none;background-color: inherit;" (change)="FilterDataByDistrict()">
                      <option style="background-color: inherit;">all</option>
                      <option style="background-color: inherit;" *ngFor="let item of districts">
                        {{ item }}
                      </option>
                  </select>
              </div>
          </div>

          </div>
      </div>
      </div>
      <div class="col-6 p-4">
        <button
          class="btn bg-upload text-white mx-3"
          data-toggle="modal"
          data-target="#uploadModal"
        >
          <i class="fas fa-plus mr-2"></i>Import market Prices
        </button>
        <button
          class="float-right btn bg-download mx-3"
          (click)="downloadList()"
        >
          <i class="fas fa-download mr-2"></i>Download
        </button>
      </div>
    </div>
    <div class="m-5">
      <table class="table table-striped">
        <thead style="height: 49px; font-size: 14px;">
          <th scope="col" style="background-color: #178bc7;color: white;">#</th>
          <th scope="col" style="width: 600px; text-align: left; background-color: #178bc7;color: white;">ITEM</th>
          <th scope="col" style="background-color: #178bc7;color: white;">AVG. RETAIL</th>
          <th scope="col" style="background-color: #178bc7;color: white;">AVG. WHOLESALE</th>
          <th scope="col" style="background-color: #178bc7;color: white;">EXPECTED DELIVERY</th>
          <th scope="col" style="background-color: #178bc7;color: white;"></th>
        </thead>
        <tbody>
          <tr *ngIf="filteredItems.length == 0">
            There are not items currently for this district
          </tr>
          <tr *ngFor="let row of filteredItems
                  let i = index">
                  <td>{{ filteredItems.indexOf(row)+ 1 }}</td>
                  <td>{{ row.crop }}</td>
                  <td>{{ row.avg_retail }}</td>
                  <td>{{ row.avg_wholesale }}</td>
                  <td>{{ row.date }}</td>

                  <td>
                    <div class="dropdown">
                      <button
                        class="btn btn-outline-info dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        ACTION
                      </button>
                      <div
                        class="dropdown-menu options"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item suspend"
                          data-toggle="modal"
                          data-target="#viewMore"
                          (click)="viewDetails(row.crop)"
                          >View/Edit</a
                        >
                      </div>
                    </div>
                  </td>
          </tr>
        </tbody>
      </table>
      <!-- <nav aria-label="Page navigation example">
          <pagination-controls (pageChange)="page = $event"></pagination-controls>
      </nav> -->
      <div class="spinner d-flex" *ngIf="loading">
          <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
      </div>
      <div class="m-4">&nbsp;</div>
    </div>
    <div class="m-4">&nbsp;</div>
</div>
</div>
<!-- upload market info modal -->
<div class="modal fade" id="uploadModal">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
    <div class="card modal-content">
        <div class="modal-header">
            <h4 class="modal-title text-info" id="modal-basic-title">Import prices</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body agronomical-view-details">
          <div class="container-fluid">
            <form (submit)="uploadMarketInfo()" class="px-2 py-2">
            <div class="form-group">
              <label for="csv">Choose csv file</label>
              <input type="file" accept=".csv" (change)="handleFileSelect($event)"
              class="form-control change-input-field" name="csv" required/>
            </div>
            <div class="alert alert-danger" *ngIf="errors">{{ errors }}</div>
            <div class="d-flex justify-content-center align-item-center form-group">
              <button class="submit-input-btn btn-success">
                <!-- <span *ngIf="loadingModal" class="spinner-border spinner-border-md
                  text-white change-loading" role="status"></span> -->
                <!-- <span class="text-danger" *ngIf="errors">{{ errors }}</span> -->
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Upload Info
                </span>
              </button>
            </div>
          </form>
            </div>
        </div>
      <!-- <div class="modal-footer">
        <a
        class="btn btn-danger text-white"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#selectedCropModal"
        (click)="prepareToDeleteInput(selectedCropRecord)"
        >Delete</a
        >
        <button type="button" class="btn btn-warning" data-dismiss="modal">
          <span class="text-white">CLOSE</span>
        </button>
      </div> -->
    </div>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>

<!--crop details modal-->
<div class="modal fade" id="viewMore">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 65%;">
    <div class="card modal-content">
        <div class="modal-header">
            <h4 class="modal-title text-info" id="modal-basic-title" *ngIf="selectedCropName">{{selectedCropName}}</h4>
            <div class="spinner d-flex" *ngIf="loading">
              <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body agronomical-view-details">
          <p class="alert alert-success" *ngIf="message && editIsSuccess">{{ message }}</p>
          <div class="container-fluid" *ngIf="cropDetails">
            <table class="table table-striped ">
              <thead w-100 class="table_head">
                <tr style="border-top: 0;">
                  <!-- <th scope="col">#</th> -->
                  <th scope="col" style="color: #2b78b0; background: #fff; border-top: 0; border-bottom: 2px solid #2b78b0;">Market</th>
                  <th scope="col" style="color: #2b78b0; background: #fff; border-top: 0; border-bottom: 2px solid #2b78b0;">Retail</th>
                  <th scope="col" style="color: #2b78b0; background: #fff; border-top: 0; border-bottom: 2px solid #2b78b0;">WholeSale</th>
                  <th scope="col" style="color: #2b78b0; background: #fff; border-top: 0; border-bottom: 2px solid #2b78b0;"></th>
                </tr>
              </thead>
              <tbody p-5 *ngIf="cropDetails">
                <tr
                  *ngFor="
                    let row of cropDetails
                    let i = index
                  "
                >
                  <!-- <td>{{ (page - 1) * count + i + 1 }}</td> -->
                  <!-- <td>{{ row.time }}</td> -->
                  <td>{{ row.market }}</td>
                  <td><input
                    id="retailprice-0"
                    type="number"
                    style="border: 0; background: inherit; width: 30%;"
                    value="{{row.retailprice[0]== '-'? 0:row.retailprice[0]}}"
                    (change)="prepareToSaveData($event,row.id)"
                    min="0" /> -
                    <input
                    id="retailprice-1"
                    type="number"
                    style="border: 0; background: inherit; width: 30%;"
                    value="{{row.retailprice[1]== '-'? 0:row.retailprice[1]}}"
                    (change)="prepareToSaveData($event,row.id)"
                    min="0" />
                  </td>
                  <td><input
                    id="wholesaleprice-0"
                    type="number"
                    style="border: 0; background: inherit; width: 30%;"
                    value="{{row.wholesaleprice[0] == '-'? 0:row.wholesaleprice[0]}}"
                    (change)="prepareToSaveData($event,row.id)"
                    min="0" /> -
                    <input
                    id="wholesaleprice-1"
                    type="number"
                    style="border: 0; background: inherit; width: 30%;"
                    value="{{row.wholesaleprice[1] == '-'? 0:row.wholesaleprice[1]}}"
                    (change)="prepareToSaveData($event,row.id)"
                    min="0" />
                  </td>

                  <td>
                    <div class="">
                        <a
                          class="delete-market-price"
                          data-toggle="modal"
                          data-target="#selectedCropModal"
                          (click)="prepareToDeleteMarketPrice(row)"
                          >Remove</a
                        >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      <div class="modal-footer">
        <button
        type="button"
        class="btn add-record-btn float-left"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#addMarketInfo"
        >
          <span class="text-white">Add market</span>
        </button>
      </div>
    </div>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>

<!-- Delete Input -->
<div class="modal fade" id="selectedCropModal">
  <div class="modal-dialog change-modal-dialog" role="document">
    <div class="modal-content" *ngIf="openDeleteModal">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete {{ inputDelete.commodity }} record
      </div>
      <div class="modal-footer">
        <span class="text-danger" *ngIf="errors">{{ errors }}</span>
        <button
          type="button"
          class="btn btn-danger"
          (click)="deleteMarketPrice(inputDelete.id)"
        >
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-md text-white
              update-loading"
            role="status"
          ></span>
          Delete record
        </button>
        <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

    <!-- add market info record -->
    <div class="modal fade" id="addMarketInfo">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add Record</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" *ngIf="addRecordSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">{{message}}</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetModal()">OK</button>
          </div>

          <div class="modal-body"  *ngIf="!addRecordSuccess">
            <span class="text-center alert alert-danger" *ngIf="serverError">{{ message }}</span>
            <form (submit)="createMarketRecord(createMarketForm.value)" #createMarketForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="market">Market</label>
                  <select
                  class="form-control form-control"
                  id="recordDistrict"
                  name="market"
                  #market="ngModel"
                  ngModel
                  required
                >
                  <option *ngFor="let cropItem of districts" class="crop">
                    {{ cropItem }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="units_of_measure">Unit</label>
                <input type="text" class="form-control change-input-field" placeholder="Unit of measure" name="units_of_measure" #units_of_measure="ngModel"
                ngModel required />
              </div>
              <div class="form-group">
                <label for="retailprice">Retail Price(UGX)</label>
                <input type="text" class="form-control change-input-field" placeholder="please enter min and max prices separated by -" name="retailprice" #retailprice="ngModel"
                ngModel required />
                <!-- <div *ngIf="retailprice.touched && !retailprice.valid" class="alert alert-danger">
                  <span *ngIf="retailprice.errors.required" class="text-danger">
                    Please enter retail price.
                  </span>
                  <span *ngIf="retailprice.errors.pattern" class="text-danger">Only numbers are allowed.</span>
                </div> -->
              </div>
              <div class="form-group">
                <label for="wholesaleprice">WholeSale Price(UGX)</label>
                <input type="text" class="form-control change-input-field" placeholder="please enter min and max prices separated by -" name="wholesaleprice" #wholesaleprice="ngModel"
                ngModel required />
                <!-- <div *ngIf="wholesaleprice.touched && !wholesaleprice.valid" class="alert alert-danger">
                  <span *ngIf="wholesaleprice.errors.required" class="text-danger">
                    Please enter wholesale price.
                  </span>
                  <span *ngIf="wholesaleprice.errors.pattern" class="text-danger">Only numbers are allowed.</span>
                </div> -->
              </div>
              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn btn-success" [disabled]="!createMarketForm.form.valid">
                  <span *ngIf="loadingModal" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save Info
                  </span>
                </button>
              </div>
            </form>
          </div>
          <div class="modal-footer" *ngIf="!addRecordSuccess">
            <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
        </div>

